// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
// 引入FontAwesomeIcon组件
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from "@fortawesome/vue-fontawesome";
library.add(fas, far, fab);
// markdown
import mavonEditor from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';

Vue.use(ElementUI, { size: 'mini', zIndex: 3000 });
Vue.use(mavonEditor);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);
Vue.component("font-awesome-layers-text", FontAwesomeLayersText);

Vue.config.productionTip = false

// 缓存中存在token和project说明登录过，读取出来
let project = localStorage.getItem("project");
if (project != undefined && project) {
  store.dispatch("setProjectId", parseInt(project));
}
let token = localStorage.getItem("token");
if (token != undefined && token) {
  store.dispatch("setToken", token);
}


router.beforeEach((to, from, next) => {
  // 如果在登录界面判断是否登录过，登录过进入首页
  if (to.name == "login" || to.name == 'third-party-jump') {
    if (store.getters.getToken && store.getters.getProjectId) {
      next({ name: "dms" })
    }
    else {
      next()
    }
  }
  else {
    if (store.getters.getUser && store.getters.getUser.is_superuser) {
      // 如果去的是第三方跳转的，登录了就直接去首页
      if (to.name == 'third-party-jump') {
        next({ name: "dms" })
      }
      else {
        next()
      }
    }
    else {
      // 如果在非登录界面，判断是否登录过，没有登录进入登录界面
      if (!store.getters.getToken || !store.getters.getProjectId) {
        // 如果是第三方跳转的，不需要考虑强转到登录界面
        if (to.name == 'third-party-jump') {
          next()
        }
        else {
          next({ name: "login" })
        }
      }
      else {
        next()
      }
    }
  }
})

/* eslint-disable no-new */
const APP = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

const docx = require("docx-preview");
window.JSZip = require("jszip");
Vue.prototype.$docx = docx

export function CURRENT_VERSION() {
  return "2.0.0"
}
export function CURRENT_APP() {
  return APP
}


// WEBPACK FOOTER //
// ./src/main.js